export const make_GoodsData_Processed = (opts = {
	/** @zh 每页显示商品数量 */
	pageNum: 1,
	goodsData: [],
	goodsData_Processed: []
}) => {
	const { goodsData_Processed, goodsData, pageNum } = opts
	const len_Now = goodsData_Processed.length
	
	let i_PageNum = goodsData_Processed.length > 0 ? goodsData_Processed.length - 1 : 0
	if(! goodsData_Processed[i_PageNum]) {
		goodsData_Processed[i_PageNum] = []
	}
	if(goodsData_Processed[i_PageNum].length >= pageNum) {
		i_PageNum += 1
		if(! goodsData_Processed[i_PageNum]) {
			goodsData_Processed[i_PageNum] = []
		}
	}
	for(const [i, item] of goodsData.entries()) {
		let page_Cur = goodsData_Processed[i_PageNum]
		if(page_Cur.length >= pageNum) {
			i_PageNum += 1
			page_Cur = goodsData_Processed[i_PageNum]
			if(! page_Cur) {
				page_Cur = goodsData_Processed[i_PageNum] = []
			}
		}
		page_Cur.push(item)
	}
}


// WEBPACK FOOTER //
// ./src/components/modular/Util/Util_Goods_Item.js